import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const DriveFileMoveSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default DriveFileMoveSVG;
